import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
import FormFields from '../../../Forms/FormFields';
import './LocationDetails.css';
// import CustomOpenStreetMap from '../../../../components/common/CustomOpenStreetMap';
import MapComponent from '../../../GoogleMap/GoogleMapRender';
import Button from '../../../../components/common/Button';
import axios from '../../../../utils/axiosExt';
import config from './../../../../config/config';
import { useDispatch, useSelector } from 'react-redux';
import { setCreateMapPincodeWithHfr, setMapLatLong, setMapManualAddress, setMapManualLatLong, setMapManualLatLongClicked } from '@store/actions/facilityGeoMapAction';
import { RootState } from '@store/reducers';
import HealthFacilitySearchMapPoc from '@components/common/Esrimap/HealthFacilitySearchMapPoc';
import FacilityESRIMap from '@components/common/Esrimap/MapWrapper';
import { page_type } from '@constants/esriMapConstant';

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState: any;
  handleFormChange: (value: string | boolean, key: string) => void;
  handleLocationDetailsError: (value: any, key: string) => void;
  facilityFormState: any;
  handleLocationDetailsDataChangeOnMapFails: (data: any) => void;
};

const LocationDetails = ({
  formData,
  formState,
  handleFormChange,
  handleLocationDetailsError,
  facilityFormState,
  handleLocationDetailsDataChangeOnMapFails
}: propsType) => {
  const [latlngValidated, setlatlngValidated] = useState(false);
  const { lattitude, longitude } = formState;


  // new code
  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);
  const facilityGeoMapref = useRef(facilityGeoMap);
  const newFormData = Object.assign({}, formData);
  delete newFormData.address;

  const location = useRef({ latitude: formState['lattitude'].value ? formState['lattitude'].value : '', longitude: formState['longitude'].value ? formState['longitude'].value : '' });
  const dtCode = useRef({ dtCode: facilityFormState.district.value ? facilityFormState.district.value.match(/(\d+)(?!.*\d)/)?.[0] : '' });
  const postalCode = useRef({ postalCode: formState['pincode'].value ? formState['pincode'].value : '' });
  const selectedAddressValue: any = useRef<any>(formState['address'].value ? formState['address'].value : '');
  const [mapRender, setMapRender] = useState(false);

  useEffect(() => {
    facilityGeoMapref.current = facilityGeoMap;
  }, [facilityGeoMap]);

  useEffect(() => {
    dispatch(setMapLatLong({ latitude: formState['lattitude'].value ? formState['lattitude'].value : '', longitude: formState['longitude'].value ? formState['longitude'].value : '' }));
  }, []);

  const onLocationChange = useCallback((locationData: any) => {
    dispatch(setMapLatLong({ latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' }));
    handleFormChange(`${locationData.latitude ? Number(locationData.latitude).toFixed(5) : ''}`, 'lattitude');
    handleFormChange(`${locationData.longitude ? Number(locationData.longitude).toFixed(5) : ''}`, 'longitude');
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
  }, []);

  const onSelectLocationChange = useCallback((locationData: any) => {
    if (!facilityGeoMapref.current.mapServicesDown && config.enableArcGISMap === 'ON') {
      location.current = { latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' };
    }

    dispatch(setMapLatLong({ latitude: locationData.latitude ? Number(locationData.latitude).toFixed(5) : '', longitude: locationData.longitude ? Number(locationData.longitude).toFixed(5) : '' }));
    handleFormChange(`${locationData.latitude ? Number(locationData.latitude).toFixed(5) : ''}`, 'lattitude');
    handleFormChange(`${locationData.longitude ? Number(locationData.longitude).toFixed(5) : ''}`, 'longitude');
    handleFormChange(`${selectedAddressValue.current.value}`, 'address');

    if (locationData.latitude === '' && locationData.longitude === '') {
      handleFormChange('', 'pincode');
    }
  }, []);

  const onAddressChange = useCallback(() => {
    handleFormChange(`${selectedAddressValue.current.value}`, 'address');
  }, []);

  const onPostalCodeChange = useCallback((postalCodeData: any) => {
    postalCode.current = { postalCode: postalCodeData };
    handleFormChange(postalCodeData, 'pincode');
    handleFormChange(`${selectedAddressValue.current?.value}`, 'address');
  }, []);

  const onLocationAddressChange = useCallback((data: any, key: any) => {
    handleFormChange(`${data}`, `${key}`);
    if ((key === 'lattitude' || key === 'longitude') && !facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
      dispatch(setMapManualLatLong(true));
    }
    // if (key === 'lattitude') {
    //   location.current.latitude = data;
    // } else if (key === 'longitude') {
    //   location.current.longitude = data;
    // }
  }, []);

  const onClickLocateLatLong = () => {
    if (formState['lattitude'].value !== '' && formState['longitude'].value !== '') {
      dispatch(setMapManualLatLongClicked(true));
      if (facilityGeoMap.addPincodeWithHfr && facilityGeoMap.addPincodeWithHfr.hfrVerified === true) {
        dispatch(setCreateMapPincodeWithHfr(
          {
            hfrVerified: true,
            pincodeWithHfr: false
          }
        ));
      } else {
        dispatch(setCreateMapPincodeWithHfr(null));
      }

      location.current = { latitude: formState['lattitude'].value ? formState['lattitude'].value : '', longitude: formState['longitude'].value ? formState['longitude'].value : '' };
      dispatch(setMapManualLatLong(false));
      dispatch(setMapManualAddress(false));
    } else {

      if (formState['lattitude'].value === '') {
        const latValue = {
          isError: true,
          message: 'Enter valid latitude to continue.',
          value: '',
        };
        handleLocationDetailsError(latValue, 'lattitude');
      }
      if (formState['longitude'].value === 'longitude') {
        const longValue = {
          isError: true,
          message: 'Enter valid longitude to continue.',
          value: '',
        };
        handleLocationDetailsError(longValue, 'longitude');
      }
    }
  }

  const onformFieldChange = useCallback((data: any) => {
    handleLocationDetailsDataChangeOnMapFails(data);
  }, []);



  return (
    <>
      <div className="create_loaction_details_page">
        <form className="form_container_location_details">
          <FormFields
            formData={newFormData}
            formState={formState}
            handleFormChange={onLocationAddressChange}
          />

          <div key={'address'} className={`${'address'}_wrapper`}>
            <HealthFacilitySearchMapPoc
              selectedAddressValue={selectedAddressValue}
              formData={formData}
              formState={formState}
              objkey={'address'}
              labelName={"Address"}
              required={formData['address']['#required'] || false}
              disabled={formData['address']['#isDisabled'] || false}
              onSelectLocationChange={onSelectLocationChange}
              onAddressChange={onAddressChange}
              inputType={formState['address'].isError ? 'error' : 'general'}
              errorMessage={formState['address'].message}
              mapRender={mapRender}
              setMapRender={setMapRender}
            />
          </div>
          <div className={`locate_btn_div`}>
            {(facilityGeoMap.isManualLatLong && !facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') && <Button
              onClick={onClickLocateLatLong}
              disabled={false}
              id="locate"
              buttonName={'Locate Lat/Long.'}
              colorType={'primary'}
            />}
          </div>
          <div className="form-map">
            <FacilityESRIMap
              selectedAddressValue={selectedAddressValue}
              latitude={location.current.latitude}
              longitude={location.current.longitude}
              dtCode={dtCode.current}
              onLocationChange={onLocationChange}
              onPostalCodeChange={onPostalCodeChange}
              onformFieldChange={onformFieldChange}
              mapRender={mapRender}
              pageType={page_type.health_facility}
            />
            <div className="attributionNotes">
              Powered By <img src={`${config.root?config.root:''}/assets/images/NicBharatMaps.png`} alt="NicBharatMaps" style={{height:40}} />
            </div>
          </div>

        </form>
      </div>
    </>
  );
};

const MemoizedLocationDetails = memo(LocationDetails);
MemoizedLocationDetails.displayName = "LocationDetails"

export default MemoizedLocationDetails;
